<script>
    import { FlowRouter } from "meteor/ostrio:flow-router-extra";
    import { Meteor } from "meteor/meteor";
    import { Tracker } from "meteor/tracker";
    import { onMount } from "svelte";

    let { activeRoute = "home" } = $props();
    let menuOpen = $state(false);
    let userId = $state(null);

    const links = [
        { href: "/", label: "Home", route: "home" },
        { href: "/vehicles", label: "Vehicles", route: "vehicles" },
        { href: "/financing", label: "Financing", route: "financing" },
        { href: "/about", label: "About Us", route: "about" },
        { href: "/testimonials", label: "Testimonials", route: "testimonials" },
        { href: "/contact", label: "Contact Us", route: "contact" },
    ];

    function navigate(href) {
        FlowRouter.go(href);
        menuOpen = false;
    }

    function logout() {
        Meteor.logout(() => {
            FlowRouter.go("/");
        });
    }

    onMount(() => {
        const computation = Tracker.autorun(() => {
            userId = Meteor.userId();
        });

        return () => computation.stop();
    });
</script>

<header class="topbar">
    <div class="brand-lockup">
        <button
            class="brand brand-logo-button"
            onclick={() => navigate("/")}
            aria-label="Go to home"
        >
            <img src="/images/logo.svg" alt="VGO Auto Financing" />
        </button>

        <button
            class="brand brand-copy-button"
            onclick={() => navigate("/")}
            aria-label="Go to home"
        >
            <p class="name">VGO Auto Financing</p>
            <p class="tag">Small Dealership. Premium Service.</p>
            <div class="legacy-callouts">
                <span>Serving Winnipeg Since 2009</span>
                <span>Now Accepting Out-of-Province Applications</span>
            </div>
        </button>

        <button
            class="menu-button"
            onclick={() => (menuOpen = !menuOpen)}
            aria-label="Toggle menu"
        >
            Menu
        </button>
    </div>

    <nav class:open={menuOpen}>
        {#each links as link (link.route)}
            <a
                href={link.href}
                class:active={activeRoute === link.route}
                onclick={(event) => {
                    event.preventDefault();
                    navigate(link.href);
                }}
            >
                {link.label}
            </a>
        {/each}

        {#if userId}
            <a
                href="/mgmt/inventory"
                class:active={activeRoute === "mgmt" || activeRoute === "login"}
                onclick={(event) => {
                    event.preventDefault();
                    navigate("/mgmt/inventory");
                }}
            >
                Mgmt
            </a>
            <button class="logout" onclick={logout}>Logout</button>
        {/if}
    </nav>
</header>
